import { useScrollReveal } from '@/hooks/useScrollReveal';

const CTA_URL = 'https://www.linkedin.com/in/vinoth-trevor-skanthavarathan-01b6ba141/';

const workflows = [
  'Matter orientation: cut the time to understand where an existing file stands',
  'Chronology preparation, linked to source documents',
  'Missing-document review',
  'Source-linked questions about a file',
  'Approved-work retrieval',
  'Controlled first-draft support',
];

const steps = [
  'Discovery',
  'Workflow and knowledge assessment',
  'Bounded pilot',
  'Review against the success metric you set',
  'Expand only if it earned it',
];

const LegalPilot = () => {
  const [ref, isVisible] = useScrollReveal();

  return (
    <section
      ref={ref}
      data-testid="legal-pilot-section"
      className={`legal-section section-reveal ${isVisible ? 'visible' : ''}`}
    >
      <div className="legal-content">
        <h2 className="legal-h2" data-testid="legal-pilot-h2">
          Soundboard Matter Pilot
        </h2>

        <p className="legal-body mt-8" data-testid="legal-pilot-intro">
          One matter type. One recurring workflow. A small number of sanitized or approved files. One responsible professional. One measurable success criterion.
        </p>

        <ul className="legal-workflow-list mt-10" data-testid="legal-pilot-workflows">
          {workflows.map((w, i) => (
            <li key={`wf-${i}`} className="legal-workflow-item">
              <span className="signal-dot"></span>
              <span className="legal-body" style={{ margin: 0 }}>{w}</span>
            </li>
          ))}
        </ul>

        <div className="legal-steps mt-12" data-testid="legal-pilot-steps">
          {steps.map((step, i) => (
            <div key={`step-${i}`} className="legal-step">
              <span className="legal-step-number">{i + 1}</span>
              <span className="legal-step-text">{step}</span>
              {i < steps.length - 1 && <span className="legal-step-arrow" aria-hidden="true">&rarr;</span>}
            </div>
          ))}
        </div>

        <p className="legal-body mt-10" data-testid="legal-pilot-closing" style={{ color: 'var(--text-secondary)' }}>
          We would rather run one workflow that proves itself than sell you a rollout that stalls.
        </p>

        <div className="mt-10">
          <a
            href={CTA_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="legal-pilot-cta"
            className="cta-button"
          >
            Start with one workflow
          </a>
        </div>
      </div>
    </section>
  );
};

export default LegalPilot;
